// 9fbef606107a605d69c0edbcd8029e5d
import {
  FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST,
  FETCH_SHOP_BY_LOOK_STYLITICS_SUCCESS,
  FETCH_SHOP_BY_LOOK_STYLITICS_FAILURE,
  FETCH_SHOP_BY_LOOK_UNBXD_REQUEST,
  FETCH_SHOP_BY_LOOK_UNBXD_SUCCESS,
  FETCH_SHOP_BY_LOOK_UNBXD_FAILURE,
} from './ShopByLookStylitics.constants';

const initialState = {
  shopByLookStyliticsData: {},
  loading: {},
  errors: {},
};

const ShopByLookStyliticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST:
    case FETCH_SHOP_BY_LOOK_UNBXD_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, [action.payload.uniqueKey]: true },
        errors: { ...state.errors, [action.payload.uniqueKey]: null },
      };

    case FETCH_SHOP_BY_LOOK_STYLITICS_SUCCESS:
    case FETCH_SHOP_BY_LOOK_UNBXD_SUCCESS:
      return {
        ...state,
        shopByLookStyliticsData: {
          ...state.shopByLookStyliticsData,
          [action.payload.uniqueKey]: action.payload.data,
        },
        loading: { ...state.loading, [action.payload.uniqueKey]: false },
        errors: { ...state.errors, [action.payload.uniqueKey]: null },
      };

    case FETCH_SHOP_BY_LOOK_STYLITICS_FAILURE:
    case FETCH_SHOP_BY_LOOK_UNBXD_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, [action.payload.uniqueKey]: false },
        errors: { ...state.errors, [action.payload.uniqueKey]: action.payload.error },
      };

    default:
      return state;
  }
};

export default ShopByLookStyliticsReducer;
